import type {
    SelectCommerceEnrollmentKitRequest,
    SelectCommerceEnrollmentKitResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
export const selectCommerceEnrollmentKitOperation: CommerceOperation<
    SelectCommerceEnrollmentKitRequest,
    SelectCommerceEnrollmentKitResponse
> = Object.freeze({ name: "commerce.enrollment.kit.select" });
